import { buildHeaderMarkdown, type DocumentHeaderTemplateData } from '../api/documentMarkdown';

export const DEFAULT_FAX_TITLE = 'New clinical fax';

/**
 * Compose the initial editable fax template. The complete template is stored
 * in the draft's bodyMarkdown after creation.
 */
export function buildFaxHeaderMarkdown(draft: DocumentHeaderTemplateData): string {
  return buildHeaderMarkdown(draft.title || DEFAULT_FAX_TITLE, [
    ['To', draft.recipient.name],
    ['Organization', draft.recipient.organization],
    ['Fax', draft.recipient.faxNumber],
    ['Date', draft.date],
    ['Clinician', draft.prescriberName],
    ['Patient', draft.patientName],
    ['Date of birth', draft.patientDateOfBirth],
    ['MRN', draft.patientMrn],
  ]);
}
